import { NgModule } from '@angular/core'
import type { Routes } from '@angular/router'
import { RouterModule } from '@angular/router'

import {
  ArticleDetailsComponent,
  articleDetailsResolver,
  articleSeo,
} from '../articles/article-details/article-details.component'
import {
  EditionOverviewComponent,
  editionDetailResolver,
  editionSeo,
} from './edition-overview/edition-overview.component'

const routes: Routes = [
  {
    path: ':id',
    component: EditionOverviewComponent,
    resolve: { editionDetail: editionDetailResolver },
    data: { seo: editionSeo },
  },
  {
    path: ':id/article/:id',
    component: ArticleDetailsComponent,
    resolve: { articleDetails: articleDetailsResolver },
    data: { seo: articleSeo },
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EditionsRoutingModule {}
